import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/skip-forward-ten.vue
var o = {
	name: "DtIconSkipForwardTen",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--skip-forward-ten"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Skip Forward Ten",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6.225 2.007A4 4 0 1 0 9.978 6.42a.5.5 0 0 1 .995.106 5 5 0 1 1-1.667-4.278l.004.003.69.622v-.4a.5.5 0 0 1 1 0v1.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1 0-1h.172l-.53-.476a4 4 0 0 0-2.417-.991ZM5.192 4.038A.5.5 0 0 1 5.5 4.5v3a.5.5 0 1 1-1 0V5.707l-.146.147a.5.5 0 0 1-.707-.707l1-1a.5.5 0 0 1 .545-.109ZM6 5.25a1.25 1.25 0 0 1 2.5 0v1.5a1.25 1.25 0 0 1-2.5 0v-1.5ZM7.25 5a.25.25 0 0 0-.25.25v1.5a.25.25 0 0 0 .5 0v-1.5A.25.25 0 0 0 7.25 5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=skip-forward-ten.js.map